import React from "react";
import cx from "classnames";

import "./SidebarComponent.scss";

const SidebarComponent = ({
    title,
    children,
    noIndent
}) => (
    <div className="sidebar-component">
        <h3 className="sidebar-component__header">{title}</h3>
        <div className={cx({
            "sidebar-component__indent": !noIndent
        })}>{children}</div>
    </div>
);

export default SidebarComponent;
